import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { fmtError } from "../lib/api";
import { Logo } from "../components/site/Navbar";

export default function AdminLogin() {
  const { user, login } = useSite();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(fmtError(e2));
    } finally {
      setBusy(false);
    }
  };
  const input = "w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500";
  return (
    <div className="min-h-screen grid place-items-center bg-slate-100 court-lines px-4">
      <form onSubmit={submit} className="w-full max-w-md card p-8 md:p-10 space-y-5" data-testid="admin-login-form">
        <Logo />
        <div>
          <h1 className="font-display text-2xl font-bold text-[#0B1F44] flex items-center gap-2"><Lock className="h-5 w-5" /> Admin login</h1>
          <p className="text-sm text-slate-500 mt-1">Authorised TDBA administrator only.</p>
        </div>
        {err && <p className="rounded-xl bg-red-50 text-red-700 p-3 text-sm" data-testid="admin-login-error">{err}</p>}
        <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="admin-login-email" />
        <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} data-testid="admin-login-password" />
        <button disabled={busy} className="btn-primary w-full justify-center" data-testid="admin-login-submit">{busy ? "Signing in..." : "Sign in"}</button>
      </form>
    </div>
  );
}
